import moment from "moment-timezone";
import { useFormatter } from "../../../util/formatter";

const [formatNumber] = useFormatter();

export const getElectricBillSection = (param) => {
	const tariffType = param.tariffType;
	const tariffDesc = param.tariffDesc;
	const peakLabels = param.peakLabels;
	const EAEng = param.EAEng;
	const EAThai = param.EAThai;
	const data = param.data;
	const GYTariff_remarks = param.GYTariff_remarks;
	const savings = param.savings;

	return {
		columns: [
			{
				stack: [
					{
						text: "About Electricity bills",
						style: {
							fontSize: 15,
							italics: true,
							bold: true,
						},
					},
					{
						text: "Based on the following electricity tariff",
						margin: [0, 1, 0, 0],
					},
					{
						text: `Time of use tariff [${tariffType[0]} Tariff] `,
						margin: [0, 1, 0, 0],
					},
					{
						text: `${tariffType[1]} for ${tariffDesc}`,
						margin: [0, 1, 0, 0],
					},
					{
						margin: [0, 2, 0, 0],
						text: `Definition of ${peakLabels[0]} hours`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: "Monday – Friday from 09.00 AM to 10.00 PM",
					},
					{
						margin: [0, 2, 0, 0],
						text: `Definition of ${peakLabels[1]} hours`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: "Monday – Friday from 10.00 PM to 09.00 AM",
					},
					{
						margin: [0, 2, 0, 0],
						text: "Saturday – Sunday , National Labor Day and normal public holiday",
					},
					{
						margin: [0, 2, 0, 0],
						text: "(excluding substitution holiday and Royal Ploughing Day) from 00.00 AM to 12.00 PM",
					},
					{
						margin: [0, 2, 0, 0],
						text: `${EAEng[0]} (${EAEng[1]}) tariff`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: `${peakLabels[0]} (baht/kWh) = ${data.priceON}`,
					},
					{
						margin: [0, 2, 0, 0],
						text: `${peakLabels[1]} (baht/kWh) = ${data.priceOFF}`,
					},
					{
						margin: [0, 2, 0, 0],
						text: `Current Ft during ${data.monthRange.engQuarter}`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: `${data.FTcost} baht/kWh.`,
					},
					{
						margin: [0, 2, 0, 0],
						text: "Green Yellow Tariff",
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: GYTariff_remarks.ONpeakStr_eng,
						style: { fontSize: 8 },
					},
					{
						margin: [0, 2, 0, 0],
						text: GYTariff_remarks.OFFpeakStr_eng,
						style: { fontSize: 8 },
					},
					{
						margin: [0, 2, 0, 0],
						text: GYTariff_remarks.FTStr_eng,
						style: { fontSize: 8 },
					},
					{
						text: `Savings generated compared to Grid In ${data.monthStr.engMonth}`,
						style: ["sub_header", "savings"],
						margin: [0, 5, 0, 0],
					},
					{ text: `฿${formatNumber(savings, 2)}`, style: "savings" },
				],
			},
			{
				stack: [
					{
						text: "เกี่ยวกับบิลค่าไฟฟ้า",
						style: {
							fontSize: 14,
							italics: true,
							font: "Taviraj",
						},
						margin: [0, -5, 0, 0],
					},
					{
						style: "thai",
						text: "อ้างอิงอัตราค่าไฟฟ้าดังต่อไปนี้",
						margin: [0, -4, 0, 0],
					},
					{
						style: "thai",
						text: `อัตราตามช่วงเวลาของการใช้ (${tariffType[0]})`,
						margin: [0, -4, 0, 0],
					},
					{
						style: "thai",
						text: `${tariffType[1]} สำหรับแรงดัน ${tariffDesc}`,
						margin: [0, -4, 0, 0],
					},
					{
						text: `กำหนดช่วงเวลา  ${peakLabels[0]}`,
						style: ["sub_header", "thai"],
					},
					{
						style: "thai",
						text: "วันจันทร์ - วันศุกร์ ตั้งแต่เวลา 09.00น. จนถึง 22.00น.",
					},
					{
						text: `กำหนดช่วงเวลา ${peakLabels[1]}`,
						style: ["sub_header", "thai"],
					},
					{
						style: "thai",
						text: "วันเสาร์ - วันอาทิตย์, วันแรงงาน และวันหยุดราชการตามปกติ",
					},
					{ style: "thai", text: "วันจันทร์ – วันศุกร์ ตั้งแต่เวลา" },
					{ style: "thai", text: "22.00น. จนถึง 09.00น." },
					{ style: "thai", text: "(ไม่รวมวันหยุดชดเชยและวันพืชมงคล)" },
					{
						text: `${EAThai[0]} (${EAThai[1]}) ในปัจจุบัน`,
						style: ["sub_header", "thai"],
					},
					{
						style: "thai",
						text: `ช่วงเวลา ${peakLabels[0]} (บาท/kWh) = ${data.priceON}`,
					},
					{
						style: "thai",
						text: `ช่วงเวลา ${peakLabels[1]} (บาท/kWh) = ${data.priceOFF}`,
					},
					{
						text: `ค่า FT ในปัจจุบัน ${data.monthRange.thQuarter}`,
						style: ["sub_header", "thai"],
					},
					{ style: "thai", text: `${data.FTcost} baht/kWh.` },
					{
						text: "อัตราค่าไฟของ Green Yellow",
						style: ["sub_header", "thai"],
					},
					{
						style: ["thai", { fontSize: 7 }],
						text: GYTariff_remarks.ONpeakStr_th,
					},
					{
						style: ["thai", { fontSize: 7 }],
						text: GYTariff_remarks.OFFpeakStr_th,
					},
					{
						style: ["thai", { fontSize: 7 }],
						text: GYTariff_remarks.FTStr_th,
					},
					{
						text: `ผลประหยัดที่ได้ เมื่อเปรียบเทียบในเดือน ${data.monthStr.thMonth}`,
						style: ["sub_header", "savings", "thai"],
						margin: [0, 5, 0, 0],
					},
					{ text: `฿${formatNumber(savings, 2)}`, style: ["savings"] },
				],
			},
		],
		columnGap: 20,
	};
};

export const getNoFTCostElectricBillSection = (param) => {
	const data = param.data;
	const discRemEN = param.discRemEN;
	const discRemTH = param.discRemTH;
	const priceON = param.priceON;

	const desc_tariff = param.tariffDesc;
	const name_tariff = desc_tariff.split(" ")[0];

	let template = 2; // default is 2 because we will have more sites with fixed (no changed yearly) tariff
	if (name_tariff == "Betagro") template = 1; // only Betagro tariff will be chagned yearly

	const savings = param.savings;
	const year = moment(data.date, "DD/MM/YYYY").subtract(1, "years").format("YYYY");

	return {
		columns: [
			{
				stack: [
					{
						text: "About Electricity bills",
						style: {
							fontSize: 15,
							italics: true,
							bold: true,
						},
					},
					{
						text: "Based on the following electricity tariff",
						margin: [0, 1, 0, 0],
					},
					{
						margin: [0, 5, 0, 0],
						text: template == 1 ? `Electricity ${name_tariff} base tariff ${year}` : `Electricity ${name_tariff}`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: `${data.priceON} (baht/kWh)`,
					},
					template == 1 ? {
						margin: [0, 5, 0, 0],
						text: "Green Yellow Tariff",
						style: "sub_header",
					} : null,
					template == 1 ? {
						margin: [0, 2, 0, 0],
						text: `${priceON} ${discRemEN}`,
						style: { fontSize: 8 },
					} : null,
					{
						text: `Savings generated compared to Grid In ${data.monthStr.engMonth}`,
						style: ["sub_header", "savings"],
						margin: [0, 5, 0, 0],
					},
					{ text: `฿${formatNumber(savings, 2)}`, style: "savings" },
				],
			},
			{
				stack: [
					{
						text: "เกี่ยวกับบิลค่าไฟฟ้า",
						style: {
							fontSize: 14,
							italics: true,
							font: "Taviraj",
						},
						margin: [0, -5, 0, 0],
					},
					{
						style: "thai",
						text: "อ้างอิงอัตราค่าไฟฟ้าดังต่อไปนี้",
						margin: [0, -4, 0, 0],
					},
					{
						text: template == 1 ? `ค่าไฟฟ้าฐาน ${name_tariff} ${year}` : `ค่าไฟฟ้า ${name_tariff}`,
						style: ["sub_header", "thai"],
						margin: [0, -1, 0, 0],
					},
					{
						style: ["thai", { fontSize: 7 }],
						text: `${data.priceON} (บาท/kWh)`,
					},
					template == 1 ? {
						text: "อัตราค่าไฟของ Green Yellow",
						style: ["sub_header", "thai"],
					} : null,
					template == 1 ? {
						style: ["thai", { fontSize: 7 }],
						text: `${priceON} ${discRemTH}`,
					} : null,
					{
						text: `ผลประหยัดที่ได้ เมื่อเปรียบเทียบในเดือน ${data.monthStr.thMonth}`,
						style: ["sub_header", "savings", "thai"],
						margin: [0, 5, 0, 0],
					},
					{ text: `฿${formatNumber(savings, 2)}`, style: ["savings"] },
				],
			},
		],
		columnGap: 20,
	};
};

export const getNoFTCostElectricBillSectionPH = (param) => {
	const data = param.data;
	const discRemEN = param.discRemEN;
	const discRemPH = param.discRemTH;
	const priceON = param.priceON;

	const desc_tariff = param.tariffDesc;
	const name_tariff = desc_tariff.split(" ")[0];

	let template = 2; // default is 2 because we will have more sites with fixed (no changed yearly) tariff
	if (name_tariff == "Betagro") template = 1; // only Betagro tariff will be chagned yearly

	const savings = param.savings;
	const year = moment(data.date, "DD/MM/YYYY").subtract(1, "years").format("YYYY");

	return {
		columns: [
			{
				stack: [
					{
						text: "About Electricity bills",
						style: {
							fontSize: 15,
							italics: true,
							bold: true,
						},
					},
					{
						text: "Based on the following electricity tariff",
						margin: [0, 1, 0, 0],
					},
					{
						margin: [0, 5, 0, 0],
						text: template == 1 ? `Electricity ${name_tariff} base tariff ${year}` : `Electricity ${name_tariff}`,
						style: "sub_header",
					},
					{
						margin: [0, 2, 0, 0],
						text: `${data.priceON} (PhP/kWh)`,
					},
					template == 1 ? {
						margin: [0, 5, 0, 0],
						text: "Green Yellow Tariff",
						style: "sub_header",
					} : null,
					template == 1 ? {
						margin: [0, 2, 0, 0],
						text: `${priceON} ${discRemEN}`,
						style: { fontSize: 8 },
					} : null,
					{
						text: `Savings generated compared to Grid In ${data.monthStr.engMonth}`,
						style: ["sub_header", "savings"],
						margin: [0, 5, 0, 0],
					},
					{ text: `₱${formatNumber(savings, 2)}`, style: "savings" },
				],
			},
			{
				stack: [
					{
						text: "Tungkol sa bill ng kuryente",
						style: {
							fontSize: 15,
							italics: true,
							bold: true,
						},
					},
					{
						text: "Batay sa sumusunod na electricity tariff",
						margin: [0, 1, 0, 0],
					},
					{
						text: template == 1 ? `Base tariff ng kuryente ${name_tariff} ${year}` : `Taripa ng kuryente ${name_tariff}`,
						style: ["sub_header"],
						margin: [0, 5, 0, 0],
					},
					{
						text: `${data.priceON} (PhP/kWh)`,
					},
					template == 1 ? {
						text: "Taripa ng Green Yellow",
						style: ["sub_header"],
					} : null,
					template == 1 ? {
						text: `${priceON} ${discRemPH}`,
					} : null,
					{
						text: `Naitipid na halaga kumpara sa Grid noong buwan ng ${data.monthStr.phMonth}`,
						style: ["sub_header", "savings"],
						margin: [0, 5, 0, 0],
					},
					{ text: `₱${formatNumber(savings, 2)}`, style: ["savings"] },
				],
			},
		],
		columnGap: 20,
	};
};